import produce from 'immer';
import {
  SET_SPECIALBOXLOG_PAGINATION,
  SET_TOTAL_COUNT,
  SPECIALBOXLOG_LIST,
  SPECIALBOXLOG_LIST_REQUEST
} from '../../constants/log/specialBoxLogConstants';
import moment from 'moment';

const initialState = {
  page: 1,
  pageLength: 10,
  beginDate: moment().utc().subtract(3, 'days').format('YYYY-MM-DDT00:00:00'),
  endDate: moment().utc().format('YYYY-MM-DDT23:59:59'),
  searchCode: '',
  searchString: '',
  totalCount: 0,
};

const specialBoxLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case SPECIALBOXLOG_LIST_REQUEST:
      break;
    case SPECIALBOXLOG_LIST:
      draft.list = action.list;
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_SPECIALBOXLOG_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.beginDate = action.beginDate;
      draft.endDate = action.endDate;
      draft.searchCode = action.searchCode;
      draft.searchString = action.searchString;
      break;
    default:
      break;
  }
});

export default specialBoxLogReducer;
